export const backendEnv = (process.env.REACT_APP_BACKEND_ENV || "production") as
  | "staging"
  | "development"
  | "production"
